module.exports = __webpack_public_path__ + "static/img/dilemma03.5b0b1d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dilemma03.png
// module id = TbLv
// module chunks = 34